import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useApplicationModals } from "app/common/hooks";
import { IconButton } from "app/components/atoms/button";
import Table from "app/components/atoms/table";
import { useCollector } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import AppModals from "app/modals";

const breadcrumbItems = [
  { label: "Settings", href: "#" },
  { label: "Varian Size", href: "#" },
];

function SizeVariantPage() {
  const { openModal, setPayloads } = useApplicationModals();

  const [sizeVariants, setVariants, loader, collect] = useCollector({
    modelName: "sizeVariant",
  });

  return (
    <MainLayout
      activeSidebarNavigation="settings"
      activeSidebarChild="size-variant"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Varian Size"
      headingButtons={[
        {
          label: "Tambah Varian Size",
          type: "button",
          onClick: () => openModal("sizeVariant.create"),
        },
      ]}
    >
      <AppModals
        items={[
          "sizeVariant.create",
          "sizeVariant.update",
          "sizeVariant.delete",
        ]}
        onSuccess={{
          "sizeVariant.create": () => collect(),
          "sizeVariant.update": () => collect(),
          "sizeVariant.delete": () => collect(),
        }}
      />
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <Table.SearchBarItemWrapper>
              {/* <SearchInput placeholder="Search" /> */}
            </Table.SearchBarItemWrapper>
          </Table.SearchBarWrapper>
          {/* <Table.UtilitiesButtonWrapper>
            <IconButton icon={PrinterIcon} />
          </Table.UtilitiesButtonWrapper> */}
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={false}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>Nama Size</Table.Heading>
              <Table.Heading></Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {sizeVariants?.map((sizeVariant, key) => (
              <Table.BodyRow key={key}>
                <Table.Cell>{sizeVariant.name}</Table.Cell>
                <Table.Cell>
                  <div className="flex">
                    <IconButton
                      icon={PencilSquareIcon}
                      onClick={(e) => {
                        setPayloads("sizeVariant.update", {
                          id: sizeVariant.id,
                        });
                        openModal("sizeVariant.update");
                      }}
                    />
                    {/* <IconButton
                      icon={TrashIcon}
                      onClick={(e) => {
                        setPayloads("sizeVariant.delete", {
                          id: sizeVariant.id,
                        });
                        openModal("sizeVariant.delete");
                      }}
                    /> */}
                  </div>
                </Table.Cell>
              </Table.BodyRow>
            ))}
          </Table.Body>
        </Table.Wrapper>
      </Table.Container>
    </MainLayout>
  );
}

export default SizeVariantPage;
